import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMessage } from '.';
import type { App } from './types';

const initialState: App = {
  version: '1.0.0',
  messages: [],
};

export const applicationSlice = createSlice({
  name: '@app',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<IMessage>) => {
      state.messages.push(action.payload);
    },
    hiddenMessage: (state, action: PayloadAction<{ id: number }>) => {
      state.messages = state.messages.filter(
        item => item.id !== action.payload.id,
      );
    },
  },
});

export const { showMessage, hiddenMessage } = applicationSlice.actions;

export default applicationSlice.reducer;
